var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7635 11.8453C12.6752 11.5654 14.3344 10.1657 13.678 6.80631C13.217 4.44685 12.0993 2.68582 11.159 1.62021C10.5947 0.980715 9.63648 0.970688 9.10148 1.63491C8.07263 2.91227 7.12067 5.09385 7.9345 7.92609C9.02849 11.7333 10.943 12.1253 11.7635 11.8453Z",
    fill: "#FF4242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8998 17.1643C29.085 17.5375 31.7835 17.5002 33.0963 14.3648C34.0132 12.1749 34.094 10.3128 33.9351 9.10271C33.8378 8.3617 33.1689 7.87669 32.4331 8.00744C30.8735 8.28457 28.6951 9.26934 27.3529 11.8453C25.6025 15.2047 26.9882 16.791 27.8998 17.1643Z",
    fill: "#FF4242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29357 14.9247C6.94996 16.4924 6.56707 17.8175 6.29357 18.2841C5.38191 18.7506 3.121 19.1799 1.37062 17.1643C0.0890312 15.6885 -0.0978203 13.7225 0.0371552 12.2991C0.112656 11.5029 0.804413 10.9129 1.58738 11.076C3.63998 11.5038 5.61722 13.3094 6.29357 14.9247Z",
    fill: "#FF4242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5239 22.2033C22.9769 22.0167 21.8282 20.9715 21.6094 18.2841C21.3906 15.5966 19.8773 16.4178 19.1479 17.1643C18.4186 17.4442 16.6318 17.8362 15.319 17.1643C13.7186 16.3453 13.4189 16.8574 12.644 18.1816L12.584 18.2841C12.3551 18.6746 12.1687 19.1087 11.9715 19.5682C11.4619 20.7555 10.8796 22.112 9.30204 23.3231C7.55166 24.6668 8.57272 26.3092 9.30204 26.9624C9.48437 27.3356 10.2319 28.0821 11.7635 28.0821C12.282 28.0821 12.7604 28.0205 13.2421 27.9585C14.539 27.7915 15.8602 27.6214 18.054 28.642C20.4607 29.7618 23.9797 27.9888 25.4384 26.9624C26.2589 26.2158 27.0247 24.2189 23.5239 22.2033Z",
    fill: "#FF4242"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.834 11.6947C21.9374 11.8147 24.2122 11.026 24.4844 6.91068C24.6463 4.46364 24.262 2.42387 23.7829 0.968848C23.4036 -0.183157 22.0328 -0.337097 21.3471 0.664773C20.5041 1.89645 19.6199 3.564 19.2254 5.41316C18.4056 9.25614 18.2045 10.9459 20.834 11.6947Z",
    fill: "#FF4242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.ed6ce107faf4403585cb5b79e541c65b.svg";
export { ForwardRef as ReactComponent };